import React, { Fragment } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import AutoBindComponent from "../../common/AutoBindComponent";
import GemeenteOverzichtPageHelper from "./GemeenteOverzichtPageHelper";
import redirector from "../../../util/redirector";
import { throwException } from "../../../actions/exceptionActions";
import GemeenteOverzichtAanvragenForm from "./parts/GemeenteOverzichtAanvragenForm";
import GemeenteOverzichtFilterForm from "./parts/GemeenteOverzichtFilterForm";
import GemeenteOverzichtOrganisatiesForm from "./parts/GemeenteOverzichtOrganisatiesForm";
import GemeenteOverzichtKaartForm from "./parts/GemeenteOverzichtKaartForm";
import * as ajaxActions from "../../../actions/ajaxCounterActions";
import * as layoutActions from "../../../actions/layoutActions";
import * as sessionActions from "../../../actions/sessionActions";
import * as securityActions from "../../../actions/securityActions";
import Section from "../../common/Section";
import Fieldset from "../../common/Fieldset";
import SelectInput from "../../common/SelectInput";
import mergeDeep from "../../../util/mergeDeep";
import * as types from "../../../constants/ComponentConstants";
import { orderByPropertyName } from "../../../util/orderBy.js";

class GemeenteOverzichtPage extends AutoBindComponent {
    constructor(props, context) {
        super(props, context, true);

        this.state = {
            exportModalIsOpen: false,
            gemeenteEmailAdres: null,
            sportclubModels: [],
            openAanvragenModels: [],
            filter: {
                pageNo: 1,
                pageSize: 50,
                ascending: true,
                orderBy: "Prioriteit",
                naam: null,
                sporttak: null,
                sportdomein: null,
                sportinfrastructuur: null,
                vCode: null,
                ondernemingsnummer: null
            },
            totalPages: 1,
            domeinen: [],
            infrastructuren: [],
            showMap: false,
            markerModels: [],
            spakkiUserId: ""
        };

        this.pageHelper = new GemeenteOverzichtPageHelper(this, redirector);
    }

    componentDidMount = () => {
        super.componentDidMount();
        this.pageHelper.loadLayout();
        this.pageHelper.init();
    };

    componentDidUpdate(previousProps) {
        if ((this.props.gemeentes !== previousProps.gemeentes) && (this.props.gemeentes.length && previousProps.gemeentes.length === 0)) {
            this.pageHelper.init();
        }
    }

    handleOpenExportModal = () => this.pageHelper.openExportModal(this.props.federatieEmailAdres);
    handleCloseExportModal = () => this.pageHelper.closeExportModal();
    handleOnExportSportclubs = () => this.pageHelper.exportSportclubs();
    handleOnChange = (event) => this.pageHelper.change(event);
    handleOnSearch = () => this.pageHelper.search();
    handleOnChangePageSize = (pageSize) => this.pageHelper.changePageSize(pageSize);
    handleEditSportclub = (id, isNew, isReadonly) => this.pageHelper.editSportclub(id, isNew, isReadonly);
    handleScrollToAanvragen = () => this.pageHelper.scrollToAanvragen();
    handleOnToonKaart = () => this.pageHelper.toonKaart();
    handleonOverzichtSportInfrastructuren = () => this.pageHelper.overzichtSportInfrastructuren();
    handleOnCancelToonKaart = () => this.pageHelper.cancelToonKaart();
    handleOnLink = () => this.pageHelper.link();

    handleOnPageChange = (e, { activePage }) => {
        this.pageHelper.loadSportclubPage(activePage);
    };

    render() {
        const state = this.state;
        const props = this.props;
        const sportclubModels = state.sportclubModels;
        const openAanvragenModels = state.openAanvragenModels;
        const exportModalIsOpen = state.exportModalIsOpen;
        const gemeenteEmailAdres = state.gemeenteEmailAdres;
        const showMap = state.showMap;
        const headerStyle = { 'color': '#006fB7', 'fontSize': '32px', 'textAlign': 'center', 'fontWeight': '500', 'padding': '0px', 'margin': '0px', 'backgroundColor': 'white', 'minHeight': '91.2px', 'paddingTop': '7px' };
        const selectStyle = { 'color': '#006fB7', 'fontSize': '32px', 'textAlignLast': 'center', 'fontWeight': '500', 'padding': '0px', 'margin': 'auto', 'backgroundColor': 'white', 'minHeight': '91.2px', 'width': 'auto' };
        const overzichtSportInfrastructurenLink = props.spakkiBevragingstoolUrl + state.spakkiUserId;

        return (

            <div>
                <Fragment>
                    {props.gemeentes.length === 1 ?
                        <div style={headerStyle}>{props.gemeentes[0].naam}</div>
                        :
                        <div style={{ 'backgroundColor': 'white', 'textAlign': 'center' }}>
                            <SelectInput defaultItem="Kies je sportdienst ......" style={selectStyle} name="selectedGemeenteId" value={state.selectedGemeenteId} items={props.gemeenteOpties} onChange={this.handleOnChange} />
                        </div>
                    }
                    {this.state.selectedGemeenteId ?
                        <Section
                            title={"Beheer sportclubs in sportdatabank"}
                            color={types.COLOR_BLUE}>
                            <Fieldset>
                                {showMap ?
                                    <GemeenteOverzichtKaartForm
                                        models={state.markerModels}
                                        gemeenteNaam={props.gemeenteNaam}
                                        onCancelToonKaart={this.handleOnCancelToonKaart}
                                    />
                                    :
                                    <div>
                                        <GemeenteOverzichtFilterForm
                                            filter={state.filter}
                                            onChange={this.handleOnChange}
                                            onSearch={this.handleOnSearch}
                                            sportdomeinen={state.domeinen}
                                            sportinfras={state.infrastructuren}
                                            sporttakken={props.sporttakken}
                                            onOpenExportModal={this.handleOpenExportModal}
                                            onCloseExportModal={this.handleCloseExportModal}
                                            onExportSportclubs={this.handleOnExportSportclubs}
                                            exportModalIsOpen={exportModalIsOpen}
                                            gemeenteEmailAdres={gemeenteEmailAdres}
                                            onScrollToAanvragen={this.handleScrollToAanvragen}
                                            onToonKaart={this.handleOnToonKaart}
                                            overzichtSportInfrastructurenLink={overzichtSportInfrastructurenLink}
                                            onLink={this.handleOnLink}
                                        />
                                        {sportclubModels ?
                                            <GemeenteOverzichtOrganisatiesForm
                                                sportclubModels={sportclubModels}
                                                filter={state.filter}
                                                totalPages={state.totalPages}
                                                totalItems={state.totalItems}
                                                onPageChange={this.handleOnPageChange}
                                                onChangePageSize={this.handleOnChangePageSize}
                                                onEditSportclub={this.handleEditSportclub}
                                            /> : null}
                                        {openAanvragenModels && openAanvragenModels.length ?
                                            <GemeenteOverzichtAanvragenForm
                                                openAanvragenModels={openAanvragenModels}
                                                onEditSportclub={this.handleEditSportclub}
                                            />
                                            : null}
                                    </div>
                                }
                            </Fieldset>
                        </Section> : null}
                </Fragment>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    const gemeentes = state.security.organisations ? state.security.organisations: [];
    const gemeenteOpties = [...gemeentes.map(f => mergeDeep({}, { label: f.naam, value: f.id }))];
    const gemeenteNaam = state.security.currentOrganisationInfo.naam ? state.security.currentOrganisationInfo.naam.replace("Sportdienst ", "") : "";

    return {
        gemeenteOndernemingsnummer: state.security.currentOrganisationInfo.ondernemingsnummer,
        gemeenteId: state.security.currentOrganisationInfo.id,
        gemeenteNaam: gemeenteNaam,
        emailAdres: state.security.currentOrganisationInfo.email,
        gemeentes: gemeentes,
        gemeenteOpties: gemeenteOpties,
        sporttakken: orderByPropertyName(state.referentie.sporttakken.map((s) => mergeDeep({}, s)), "label"),
        spakkiBevragingstoolUrl: state.settings.spakkiBevragingstoolUrl
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        ajaxActions: bindActionCreators(ajaxActions, dispatch),
        throwException: bindActionCreators(throwException, dispatch),
        loadOverzichtLayout: bindActionCreators(layoutActions.loadGemeenteOverzichtPageLayout, dispatch),
        setUserType: bindActionCreators(sessionActions.setUserType, dispatch),
        setCurrentOrganisation: bindActionCreators(securityActions.setCurrentOrganisation, dispatch),
        setActiveSportclub: bindActionCreators(sessionActions.setActiveSportclubId, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(GemeenteOverzichtPage);
